import { PoolImage } from '@synergy/components-next';
import { ReactElement } from 'react';
import { styled } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { useArticleDetailContext } from '../article-detail';

const SupplierImage = styled(PoolImage)(({ theme }) => ({
    height: theme.spacing(9),
    maxWidth: 168,
    objectFit: 'contain',
    cursor: 'pointer',
}));

export const ArticleDetailSupplierImage = (): ReactElement | null => {
    const { article } = useArticleDetailContext();
    const navigate = useNavigate();

    const supplierImageSrc = article.supplier.image;
    const supplierName = article.supplier.name;

    if (!supplierImageSrc) {
        return null;
    }

    const handleSupplierImageClick = (): void => {
        navigate(`/supplier-directory/${article.supplier.id}`);
    };

    return (
        <SupplierImage
            src={supplierImageSrc['168x72']}
            alt={supplierName ? `${supplierName}-logo` : 'supplier-logo'}
            onClick={handleSupplierImageClick}
        />
    );
};
